<div class="bannerimage">
    <img src="{{imagepath}}portimages/{{PortInfo?.gpiImage}}" class="img-fluid" alt="...">
</div>